import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { SignInEmailSubscriptionResponse } from './inspection-email-subscription-response';
import { SignInEmailSubscriptionsRequest } from './inspection-email-subscriptions-request';

const path = 'visitor-email-subscriptions';

@Injectable({
  providedIn: 'root',
})
export class SignInsEmailSubscriptionsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  getAll(): Observable<SignInEmailSubscriptionResponse[]> {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<SignInEmailSubscriptionResponse[]>(url);
  }

  getForWorkspace(workspaceCode: string): Observable<SignInEmailSubscriptionResponse[]> {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${workspaceCode}`);

    return this.httpClient.get<SignInEmailSubscriptionResponse[]>(url);
  }

  post(
    request: SignInEmailSubscriptionsRequest
  ): Observable<SignInEmailSubscriptionResponse[]> {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post<SignInEmailSubscriptionResponse[]>(
      url,
      request
    );
  }

  delete(id: string): Observable<void> {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${id}`);

    return this.httpClient.delete<void>(url);
  }
}
